export const PAYMENT_TYPES = {
  E100Card: 'E100Card',
  E100Mobility: 'E100Mobility'
};
